<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('app', ['appVersion', 'environment'])
  }
}
</script>

<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() }} © OMS bv</div>
        <div class="col-sm-6">
          <div class="text-sm-right d-none d-sm-block" :title="environment">
            v{{ appVersion }} Powered By Hasura
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
